import { AppState } from '../store';

export const preferencesSelector = (state: AppState) => ({
  lastAction: state.userReducer.lastAction,
  error: state.userReducer.error,
  hasLoaded: state.userReducer.hasLoaded,
  isLoading: state.userReducer.isLoading,
  preferences: state.userReducer.preferences
});
